import React from "react";

const Banner = ({title}) => {
  return (
    <section className="home-slider ">
      <div
        className="slider-item"
        style={{backgroundImage: `url("/images/bg_3.jpg")`, backgroundAttachment: "fixed", height: "45vh",   }}
        data-stellar-background-ratio="0.5"
      >
        <div className="overlay"></div>
        <div className="container">
          <div className="row slider-text justify-content-center align-items-center">
            <div className="col-md-7 col-sm-12 text-center ">
              <h1 className="mb-3 mt-5 bread text-white">{title}</h1>
              {/* <p className="breadcrumbs">
               
                  <a href="/" className="text-white text-decoration-none">Home / <span>{title}</span></a>
  
              </p> */}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Banner;
